import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { staffAccessLogsService } from '../api/staff-access-logs.service';

export function useStaffAccessLogsQuery(
  filters: { page: number; limit: number; staffEmail?: string },
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: queryKeys.staffAccessLogs.page(filters),
    queryFn: () => staffAccessLogsService.list(filters),
    placeholderData: keepPreviousData,
    enabled: options?.enabled ?? true,
  });
}
